module.exports = __webpack_public_path__ + "withdraw_stmx_button_1.svg?918a5da65f2b3c3e2cd6f00e39163b97";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw_stmx_button_1.svg
// module id = 963
// module chunks = 2